module.exports = __webpack_public_path__ + "img/hero-03-1.09b6621c.jpg";